import { ShieldCheck } from "lucide-react";

/**
 * Trust badge shown when a partner has passed eKYC + signed agreements
 * (kyc_status === "verified"). Use across account profile and admin lists.
 */
export const VerifiedPartnerBadge = ({ size = "md", className = "", testid = "verified-partner-badge" }) => {
  const s = size === "sm"
    ? { pad: "px-2.5 py-1", text: "text-[10px]", icon: 12 }
    : { pad: "px-3.5 py-1.5", text: "text-[11px]", icon: 14 };
  return (
    <span
      data-testid={testid}
      className={`inline-flex items-center gap-1.5 rounded-full border border-[#2FB999]/45 bg-[#2FB999]/10 text-[#2FB999] font-grotesk uppercase tracking-[0.16em] ${s.pad} ${s.text} ${className}`}
    >
      <ShieldCheck size={s.icon} /> Verified Partner
    </span>
  );
};
